var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13116_63617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2468 3.60615L20.4674 0.768852C19.9852 0.276568 19.3312 3.64042e-06 18.6492 0L9.42857 0C8.00839 0 6.85714 1.17523 6.85714 2.625V5.25H2.57143C1.15125 5.25 0 6.42523 0 7.875V25.375C0 26.8248 1.15125 28 2.57143 28H14.5714C15.9916 28 17.1429 26.8248 17.1429 25.375V22.75H21.4286C22.8488 22.75 24 21.5748 24 20.125V5.4623C24 4.76611 23.7291 4.09843 23.2468 3.60615ZM14.25 25.375H2.89286C2.80761 25.375 2.72585 25.3404 2.66557 25.2789C2.60529 25.2174 2.57143 25.1339 2.57143 25.0469V8.20312C2.57143 8.1161 2.60529 8.03264 2.66557 7.97111C2.72585 7.90957 2.80761 7.875 2.89286 7.875H6.85714V20.125C6.85714 21.5748 8.00839 22.75 9.42857 22.75H14.5714V25.0469C14.5714 25.1339 14.5376 25.2174 14.4773 25.2789C14.417 25.3404 14.3352 25.375 14.25 25.375ZM21.1071 20.125H9.75C9.66475 20.125 9.583 20.0904 9.52272 20.0289C9.46244 19.9674 9.42857 19.8839 9.42857 19.7969V2.95312C9.42857 2.8661 9.46244 2.78264 9.52272 2.72111C9.583 2.65957 9.66475 2.625 9.75 2.625H15.4286V7.4375C15.4286 8.16238 16.0042 8.75 16.7143 8.75H21.4286V19.7969C21.4286 19.8839 21.3947 19.9674 21.3344 20.0289C21.2741 20.0904 21.1924 20.125 21.1071 20.125ZM21.4286 6.125H18V2.625H18.516C18.6012 2.625 18.683 2.65956 18.7433 2.72109L21.3344 5.36621C21.3643 5.39668 21.388 5.43286 21.4041 5.47267C21.4203 5.51249 21.4286 5.55516 21.4286 5.59825V6.125Z",
    fill: "#FF0990"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13116_63617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.e1a0d6b5.svg";
export { ForwardRef as ReactComponent };